"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeView = void 0;
const react_1 = __importStar(require("react"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const Overlay_1 = require("../Overlay");
const Spinner_1 = require("../Spinner");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const nodeData_1 = require("./nodeData");
const selectionHelpers_1 = require("./selectionHelpers");
const TreeNode_1 = require("./TreeNode");
const types_1 = require("./types");
const ScrollableWrapper = styled_components_1.default.div `
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;

    ${({ spaceFill }) => spaceFill === View_1.SPACE_FILL.all &&
    (0, styled_components_1.css) `
            height: 100%;
            width: 100%;
            box-sizing: border-box;
        `}

    ${({ bordered, error, disabled, theme }) => {
    if (disabled && bordered) {
        return (0, styled_components_1.css) `
                border: 1px solid ${theme.colors.borders.disabled};
            `;
    }
    if (!disabled && error) {
        return (0, styled_components_1.css) `
                border: 1px solid ${theme.colorBorderError};
                background-color: ${theme.colorBackgroundError};
            `;
    }
    return (bordered &&
        (0, styled_components_1.css) `
                border: 1px solid ${theme.colors.borders.normal};
            `);
}}
`;
const Body = (0, styled_components_1.default)(View_1.View) `
    position: relative;
    display: flex;
    flex: 1;
    min-width: 100%;
`;
const NoDataWrapper = (0, styled_components_1.default)(View_1.View) `
    height: ${({ theme }) => theme.spacing.xl};
`;
exports.TreeView = (0, helpers_1.createUIElement)('TreeView', function (_a, ref) {
    var { className, nodeData, nodeRenderer, onSelect, onActivateNode, onToggleExpandNode, onCheck, onExpand, onContextMenu, selected = [], checked = [], expanded = [], loading, iconRenderer, hideIcon = false, bordered = false, checkable = false, checkableConfig = {
        checkableNode: false,
        checkableHighlighting: false,
        activateNodeOnCheck: true
    }, checkBehavior = types_1.TREE_VIEW_CHECK_BEHAVIOR.simple, disabled = false, error, expandAll = false, isNodeLoading, isNodeDisabled, nodeWarningGetter, autoHeight, style, noDataPlaceholder = 'No data to display', expandBehavior: expandBehaviorProp = types_1.TREE_VIEW_EXPAND_BEHAVIOR.none, spaceFill, nodeVerticalAlign = StackView_1.STACK_ALIGN.start, apiRef, onMouseEnter, onMouseLeave } = _a, rest = __rest(_a, ["className", "nodeData", "nodeRenderer", "onSelect", "onActivateNode", "onToggleExpandNode", "onCheck", "onExpand", "onContextMenu", "selected", "checked", "expanded", "loading", "iconRenderer", "hideIcon", "bordered", "checkable", "checkableConfig", "checkBehavior", "disabled", "error", "expandAll", "isNodeLoading", "isNodeDisabled", "nodeWarningGetter", "autoHeight", "style", "noDataPlaceholder", "expandBehavior", "spaceFill", "nodeVerticalAlign", "apiRef", "onMouseEnter", "onMouseLeave"]);
    const dataSelectorId = rest['data-selector-id'] || 'treeview';
    const expandBehavior = expandAll ? types_1.TREE_VIEW_EXPAND_BEHAVIOR.expandAll : expandBehaviorProp;
    const prevNodeData = (0, react_1.useRef)([]);
    const prevSelected = (0, react_1.useRef)([]);
    const { getValue: getChecked } = (0, helpers_1.useStateValue)(checked, [checked]);
    const { getValue: getExpanded, setValue: setExpanded } = (0, helpers_1.useStateValue)(expanded, [
        expanded
    ]);
    const containerRef = ref ? ref : (0, react_1.useRef)(null);
    if (!onExpand) {
        onExpand = setExpanded;
    }
    const onCheckedNode = (0, react_1.useCallback)((node) => {
        var _a;
        onCheck === null || onCheck === void 0 ? void 0 : onCheck((0, selectionHelpers_1.computeCheckedIds)(checkBehavior, node, (_a = getChecked()) !== null && _a !== void 0 ? _a : []));
    }, [onCheck, checkBehavior]);
    const onActivateNodeCallback = (0, react_1.useCallback)((node) => {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect([node.id]);
        onActivateNode === null || onActivateNode === void 0 ? void 0 : onActivateNode(node);
    }, [onSelect, onActivateNode]);
    const toggleExpandNodeCallback = (0, react_1.useCallback)((node) => {
        const prevExpanded = getExpanded();
        const foundIndex = prevExpanded.findIndex((expandedId) => expandedId === node.id);
        const isExpanded = foundIndex === -1;
        if (!isExpanded) {
            const newExpanded = prevExpanded.slice();
            newExpanded.splice(foundIndex, 1);
            onExpand === null || onExpand === void 0 ? void 0 : onExpand([...newExpanded]);
        }
        else {
            onExpand === null || onExpand === void 0 ? void 0 : onExpand([...prevExpanded, node.id]);
        }
        onToggleExpandNode === null || onToggleExpandNode === void 0 ? void 0 : onToggleExpandNode(node, isExpanded);
    }, [onExpand, onToggleExpandNode]);
    const expandNodes = (nodes) => {
        const result = [...getExpanded()];
        nodes.forEach((node) => {
            if (result.findIndex((expandedId) => expandedId === node.id) === -1) {
                result.push(node.id);
            }
        });
        onExpand === null || onExpand === void 0 ? void 0 : onExpand(result);
    };
    const expandToNodes = (nodeIds) => {
        const result = [];
        nodeIds.forEach((nodeId) => {
            let foundNode;
            nodeData.some((node) => (foundNode = node.getById(nodeId)));
            if (foundNode) {
                result.push(...foundNode.getAncestors().slice(1));
            }
        });
        expandNodes(result);
    };
    const needExpandAll = () => {
        return (expandBehavior === types_1.TREE_VIEW_EXPAND_BEHAVIOR.expandAll &&
            !nodeData_1.NodeData.equalNodes(prevNodeData.current, nodeData));
    };
    const needExpandToSelected = () => {
        return ((expandBehavior === types_1.TREE_VIEW_EXPAND_BEHAVIOR.expandToSelected ||
            expandBehavior === types_1.TREE_VIEW_EXPAND_BEHAVIOR.expandToSelectedAndChecked) &&
            selected &&
            !(0, fast_deep_equal_1.default)(prevSelected.current, selected) &&
            selected.every((selectedId) => nodeData.some((node) => node.getById(selectedId))));
    };
    const needExpandToChecked = () => {
        return ((expandBehavior === types_1.TREE_VIEW_EXPAND_BEHAVIOR.expandToChecked ||
            expandBehavior === types_1.TREE_VIEW_EXPAND_BEHAVIOR.expandToSelectedAndChecked) &&
            checked &&
            checked.every((checkedId) => nodeData.some((node) => node.getById(checkedId))));
    };
    const getFlattenNodesForRender = () => {
        return nodeData.reduce((acc, currNode) => {
            var _a;
            let current;
            const visitors = [currNode];
            while ((current = visitors.pop())) {
                acc.push(current);
                if (getExpanded().includes(current.id)) {
                    visitors.push(...((_a = current.children) !== null && _a !== void 0 ? _a : []).slice().reverse());
                }
            }
            return acc;
        }, []);
    };
    const handleScrollToNodeById = (0, react_1.useCallback)((id, scrollBehavior = 'smooth') => {
        const node = (0, selectionHelpers_1.findNodeById)(id, nodeData);
        if (!node) {
            throw new Error('Wrong node id');
        }
        if (!(0, selectionHelpers_1.isNodeVisible)(node, getExpanded())) {
            expandToNodes([id]);
        }
        requestAnimationFrame(() => {
            var _a, _b;
            const nodeElementSelector = (0, selectionHelpers_1.getNodeDataSelectorId)(dataSelectorId, node);
            (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-selector-id=${nodeElementSelector}]`)) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: scrollBehavior });
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (apiRef) {
            apiRef.current = {
                scrollToNodeById: handleScrollToNodeById
            };
        }
    }, [apiRef]);
    (0, react_1.useLayoutEffect)(() => {
        if (needExpandAll()) {
            prevNodeData.current = nodeData;
            onExpand === null || onExpand === void 0 ? void 0 : onExpand(nodeData.reduce((acc, node) => {
                node.getDescendants().forEach((node) => {
                    var _a;
                    if (!!((_a = node.children) === null || _a === void 0 ? void 0 : _a.length)) {
                        acc.push(node.id);
                    }
                });
                return acc;
            }, []));
            return;
        }
        if (needExpandToSelected()) {
            prevSelected.current = selected;
            expandToNodes(selected);
        }
    });
    (0, react_1.useLayoutEffect)(() => {
        if (needExpandToChecked()) {
            expandToNodes(checked);
        }
    }, [loading]);
    const renderData = getFlattenNodesForRender();
    return (react_1.default.createElement(ScrollableWrapper, Object.assign({}, rest, { "data-selector-id": dataSelectorId, className: `vm-TreeView ${className}`, bordered: bordered, disabled: disabled, error: !!error, spaceFill: loading ? View_1.SPACE_FILL.all : spaceFill, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: containerRef, style: style }),
        loading && (react_1.default.createElement(Overlay_1.Overlay, { "data-selector-id": `${dataSelectorId}-spinner-wrapper`, view: Overlay_1.OVERLAY_VIEW.soft, contentMod: Overlay_1.OVERLAY_CONTENT_MOD.center },
            react_1.default.createElement(Spinner_1.Spinner, { size: 50 }))),
        !loading && (react_1.default.createElement(Body, { "data-selector-id": `${dataSelectorId}-body`, align: View_1.VIEW_ALIGN.start },
            !renderData.length && (react_1.default.createElement(NoDataWrapper, { spaceHorizontal: View_1.INDENT.s, contentMod: View_1.VIEW_CONTENT_MOD.center },
                react_1.default.createElement(Text_1.Text, { "data-selector-id": `${dataSelectorId}-no-data` }, noDataPlaceholder))),
            renderData.map((node) => {
                var _a, _b;
                return (react_1.default.createElement(TreeNode_1.TreeNode, { key: String(node.id), "data-selector-id": (0, selectionHelpers_1.getNodeDataSelectorId)(dataSelectorId, node), node: node, selected: selected.includes(node.id), renderer: nodeRenderer, autoHeight: autoHeight, depth: node.depth, onActivateNode: onActivateNodeCallback, onContextMenu: onContextMenu, iconRenderer: iconRenderer, hideIcon: hideIcon, checkable: checkable, checked: (0, selectionHelpers_1.isNodeChecked)(node, getChecked(), checkBehavior), indeterminate: (0, selectionHelpers_1.isNodeIndeterminated)(node, getChecked(), checkBehavior), onCheckedNode: onCheckedNode, checkableConfig: {
                        checkableNode: checkableConfig.checkableNode,
                        checkableHighlighting: checkableConfig.checkableHighlighting,
                        activateNodeOnCheck: checkableConfig.activateNodeOnCheck
                    }, align: nodeVerticalAlign, disabled: disabled || ((_a = isNodeDisabled === null || isNodeDisabled === void 0 ? void 0 : isNodeDisabled(node)) !== null && _a !== void 0 ? _a : false), expanded: getExpanded().includes(node.id), loading: (_b = isNodeLoading === null || isNodeLoading === void 0 ? void 0 : isNodeLoading(node)) !== null && _b !== void 0 ? _b : false, warning: (nodeWarningGetter === null || nodeWarningGetter === void 0 ? void 0 : nodeWarningGetter(node)) || '', onExpandNode: toggleExpandNodeCallback }));
            })))));
});
//# sourceMappingURL=TreeView.js.map